module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Black.09e365e8.ttf";